<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>二级商户签约</span>
      <el-steps :active="1" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 填写签约信息" icon="el-icon-edit-outline"></el-step>
        <el-step title="2 签约信息确认" icon="el-icon-s-platform"></el-step>
        <el-step title="3 证照资料上传" icon="el-icon-s-check"></el-step>
        <el-step title="4 签约成功" icon="el-icon-success"></el-step>
      </el-steps>
      <el-button class="but2">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">填写签约信息</span>
      </el-button>
      <el-form class="form" :model="signInfo" :rules="rules" ref="signInfo" label-width="250px">
        <el-form-item class="sp3" label="二级商户名称" prop="subMerName" style="margin-top: 20px">
          <el-input v-model="signInfo.subMerName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="二级商户经营名称" prop="subMerchantShortName">
          <el-input v-model="signInfo.subMerchantShortName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="客服电话" prop="servicePhone">
          <el-input v-model="signInfo.servicePhone" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：只能为数字或021-85104727类型的号码</span>
        </el-form-item>
        <el-form-item class="sp3" label="实际经营地址" prop="address">
          <el-input v-model="signInfo.address" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：请填写实际经营地址，省-市-区-详细地址。如：北京市北京市东城区邮通街50号</span>
        </el-form-item>
        <el-form-item class="sp3" label="二级商户类型" prop="subMerType">
          <el-select v-model="signInfo.subMerType" placeholder="请选择" style="width: 300px">
            <el-option v-for="item in subMemTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sp3" label="二级商户证件类型" prop="companyCertType">
          <el-select v-model="signInfo.companyCertType" placeholder="请选择" style="width: 300px">
            <el-option v-for="item in certTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sp3" label="二级商户证件编号" prop="companyCertNo">
          <el-input v-model="signInfo.companyCertNo" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="二级商户证件有效期结束时间" prop="endCertificateValidity">
          <el-input v-model="signInfo.endCertificateValidity" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：默认长期，若不为长期请填写具体日期。例：20221221</span>
        </el-form-item>
        <el-form-item class="sp3" label="法人/经营者姓名" prop="contactName">
          <el-input v-model="signInfo.contactName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="法人/经营者证件类型" prop="companyCertType">
          <el-select v-model="signInfo.certificateType" placeholder="请选择" style="width: 300px">
            <el-option v-for="item in certificateTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sp3" label="法人/经营者证件编号" prop="certificateNo">
          <el-input v-model="signInfo.certificateNo" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="法人/经营者证件有效期开始时间" prop="certificateBegDate">
          <el-input v-model="signInfo.certificateBegDate" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：例：20221221</span>
        </el-form-item>
        <el-form-item class="sp3" label="法人/经营者证件有效期结束时间" prop="frCertEndDate">
          <el-input v-model="signInfo.frCertEndDate" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：若有效期为长期，请填写：20991231</span>
        </el-form-item>
        <el-form-item class="sp3" label="法人/经营者证件居住地址" prop="frResidence">
          <el-input v-model="signInfo.frResidence" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：请填写实际经营地址，省-市-区-详细地址。如：北京市北京市东城区邮通街50号</span>
        </el-form-item>
        <el-form-item class="sp3" label="商户联系人姓名" prop="subMerContactName">
          <el-input v-model="signInfo.subMerContactName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="商户联系人证件号码" prop="subMerContactCert">
          <el-input v-model="signInfo.subMerContactCert" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="商户联系人联系电话" prop="merMobilePhone">
          <el-input v-model="signInfo.merMobilePhone" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="商户联系人邮箱" prop="subMerContactMail">
          <el-input v-model="signInfo.subMerContactMail" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="银行账号" prop="account">
          <el-input v-model="signInfo.account" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="银行账户户名" prop="accountName">
          <el-input v-model="signInfo.accountName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="开户银行名称" prop="bankName">
          <el-input v-model="signInfo.bankName" style="width: 300px"></el-input>
          <span style="color: red;margin-left: 20px">提示：开户银行名称，例：中国农业银行股份有限公司</span>
        </el-form-item>
        <el-form-item class="sp3" label="银行预留手机号" prop="mobilePhone">
          <el-input v-model="signInfo.mobilePhone" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item class="sp3" label="收款账户类型" prop="accountType">
          <el-select v-model="signInfo.accountType" placeholder="请选择" style="width: 300px">
            <el-option v-for="item in accountTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center;margin-left: -300px">
          <el-button type="primary" @click="submitForm('signInfo')">提交签约信息</el-button>
        </el-form-item>
      </el-form>
      <div class="note">
        <span>1、账户类型为个人银行卡（借记卡、二类户、三类户）时，银行账户户名必须与法人/经营者姓名一致；账户类型为：对公账户（企业户）时，户名必须与营业执照上的“二级商户名称”一致;</span><br>
        <span>2、【二级商户签约确认】和【二级商户资料上传】是给签约申请通过但未完善资料的公司使用，如已经签约成功则忽略这两项；</span><br>
        <span>3、【二级商户签约查询】是查看当前公司签约历史记录和解约使用，每个公司目前只支持签约一个二级商户。</span><br>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {signApply} from "../../../api/system/bank_abc";
import {mapGetters} from "vuex";

export default {
  data(){
    return{
        signInfo:{
          subMerId:'',//二级商户编号
          newSubMerFlag:1,//新增二级商户标识,1新增，0修改
          subMerName:'',//二级商户名称
          subMerchantShortName:'',//二级商户经营名称
          servicePhone:'',//二级商户客服电话
          industry:'0101',//二级商户所属行业
          bussinessRange:'',//二级商户经营范围
          address:'',//二级商户实际经营地址
          subMerType:'2',//二级商户类型
          companyCertType:'611009',//二级商户证件类型
          companyCertNo:'',//二级商户证件编号
          endCertificateValidity:'长期',//二级商户证件有效期结束时间
          subMerClass:'2',//个人商户类别:2 网络商户
          contactName:'',//法定代表人/经营者姓名
          certificateType:'110001',//法定代表人/经营者证件类型
          certificateNo:'',//法定代表人/经营者证件编号
          certificateBegDate:'',//法定代表人/经营者证件有效期开始时间
          frCertEndDate:'',//法定代表人/经营者证件有效期结束时间
          frResidence:'',//法定代表人/经营者证件居住地址
          frIsController:'1',//法定代表人/经营者是否为受益所有人 1否
          controllerName:'',//受益所有人姓名
          controllerCertType:'',//受益所有人证件类型
          controllerCertNo:'',//受益所有人证件号码
          controllerCertBegDate:'',//受益所有人证件有效期开始时间
          controllerCertEndDate:'',//受益所有人证件有效期结束时间
          controllerResidence:'',//受益所有人证件居住地址
          frIsAgent:'1',//法定代表人/经营者是否为实际办理业务人员 1是 0否
          agentName:'',//授权办理业务人员姓名
          agentCertType:'',//授权办理业务人员证件类型
          agentCertNo:'',//授权办理业务人员证件号码
          agentCertBegDate:'',//授权办理业务人员证件有效期开始时间
          agentCertEndDate:'',//授权办理业务人员证件有效期结束时间
          agentResidence:'',//授权办理业务人员证件居住地址
          subMerContactName:'',//商户联系人姓名
          subMerContactCert:'',//商户联系人证件号码
          merMobilePhone:'',//商户联系人联系电话
          subMerContactMail:'',//商户联系人邮箱
          subMerContactType:'01',//商户联系人业务标识 01：商户信息核实联系人
          account:'',//银行账号
          replacedAccount:'',//要更换的旧账号
          accountName:'',//银行账户户名
          bankName:'中国农业银行股份有限公司',//开户银行名称
          mobilePhone:'',//银行预留手机号
          accountType:'601',//账户类型
          applyService:'111000',//申请服务
          announce:'1',//声明已签署三方协议 1 已声明
          remark:'',//附言
          // notifyUrl:'https://member.godaji.com/business/order/abcSubMerCallback',//审核结果通知地址
          notifyUrl:'https://wellhope.godaji.com/osp/companySign/abcSubMerCallback',//审核结果通知地址
          companyId:''//公司ID，财务组织id
        },
        rules:{
          subMerName:[
            { required: true , message:'请输入二级商户名称' , trigger: 'blur'}
          ],
          subMerchantShortName:[
            { required: true , message:'请输入二级商户经营名称' , trigger: 'blur'}
          ],
          servicePhone:[
            { required: true , message:'请输入客服电话' , trigger: 'blur'}
          ],
          address:[
            { required: true , message:'请输入实际经营地址' , trigger: 'blur'}
          ],
          subMerType:[
            { required: true , message:'请选择二级商户类型' , trigger: 'change'}
          ],
          companyCertType:[
            { required: true , message:'请选择二级商户证件类型' , trigger: 'change'}
          ],
          companyCertNo:[
            { required: true , message:'请输入二级商户证件编号' , trigger: 'blur'}
          ],
          endCertificateValidity:[
            { required: true , message:'有效期为长期或指定日期' , trigger: 'change'}
          ],
          contactName:[
            { required: true , message:'请输入法人/经营者姓名' , trigger: 'blur'}
          ],
          certificateType:[
            { required: true , message:'请选择法人/经营者证件类型' , trigger: 'change'}
          ],
          certificateNo:[
            { required: true , message:'请输入法人/经营者证件编号' , trigger: 'blur'}
          ],
          certificateBegDate:[
            { required: true , message:'有效期为长期或指定日期' , trigger: 'change'}
          ],
          frCertEndDate:[
            { required: true , message:'有效期为20991231或指定日期' , trigger: 'change'}
          ],
          frResidence:[
            { required: true , message:'请输入法人/经营者证件居住地址' , trigger: 'blur'}
          ],
          subMerContactName:[
            { required: true , message:'请输入商户联系人姓名' , trigger: 'blur'}
          ],
          subMerContactCert:[
            { required: true , message:'请输入商户联系人证件号码' , trigger: 'blur'}
          ],
          merMobilePhone:[
            { required: true , message:'请输入商户联系人联系电话' , trigger: 'blur'}
          ],
          subMerContactMail:[
            { required: true , message:'请输入商户联系人邮箱' , trigger: 'blur'}
          ],
          account:[
            { required: true , message:'请输入银行账号' , trigger: 'blur'}
          ],
          accountName:[
            { required: true , message:'请输入银行账户户名' , trigger: 'blur'}
          ],
          bankName:[
            { required: true , message:'请输入开户银行名称' , trigger: 'blur'}
          ],
          mobilePhone:[
            { required: true , message:'银行预留手机号' , trigger: 'blur'}
          ],
          accountType:[
            { required: true , message:'请选择收款账户类型' , trigger: 'change'}
          ]
        },
        subMemTypeOptions:[{
          value:'1',
          label:'个人商户'
        },{
          value:'2',
          label:'企业商户'
        },{
          value:'3',
          label:'个体工商户'
        },{
          value:'4',
          label:'政府、金融机构及事业单位'
        }],
       certTypeOptions:[{
          value:'610049',
          label:'个体工商户营业执照'
       },{
         value:'610047',
         label:'企业营业执照'
       },{
         value:'610001',
         label:'组织机构代码'
       },{
         value:'611009',
         label:'统一社会信用代码'
       },{
         value:'610170',
         label:'事业单位法人证书'
       },{
         value:'610023',
         label:'社会团体登记证书'
       },{
         value:'610025',
         label:'民办非企业登记证书'
       },{
         value:'610079',
         label:'农民专业合作社营业执照'
       },{
         value:'610033',
         label:'主管部门颁居民委员会（村民委员会、社区委员会）批文'
       },{
         value:'610037',
         label:' 政府主管部门批文'
       },{
         value:'610039',
         label:'财政部门证明'
       },{
         value:'619999',
         label:'其他机构证件标识'
       }],
      certificateTypeOptions:[{
         value:'110001',
         label:'身份证'
      },{
        value:'110003',
        label:'临时居民身份证'
      },{
        value:'110007',
        label:'中国人民解放军军人身份证件'
      },{
        value:'110009',
        label:'中国人民武装警察身份证件'
      },{
        value:'110019',
        label:'港澳居民来往内地通行证'
      },{
        value:'110021',
        label:'台湾居民来往大陆通行证'
      },{
        value:'110023',
        label:'中华人民共和国护照'
      },{
        value:'110025',
        label:'外国护照'
      },{
        value:'119999',
        label:'其他证件'
      }],
      accountTypeOptions:[{
        value:'401',
        label:'借记卡'
      },{
          value:'601',
          label:'企业户'
        },{
        value:'701',
        label:'二类户'
      },{
        value:'702',
        label:'三类户'
      }
      ],
      timeLineHeight: ""
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted(){
    this.timeLineHeight = document.documentElement.clientHeight -50;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
    if(this.index === null){
      this.$message({
        type:'error',
        message:'请在财务组织选择页面选取个人所属公司！'
      });
      return;
    }
    this.signInfo.subMerName = this.companyOrgs[this.index].name;
    this.signInfo.subMerchantShortName = this.companyOrgs[this.index].name;
    this.signInfo.accountName = this.companyOrgs[this.index].name;
    this.signInfo.companyId = this.companyOrgs[this.index].id;
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    submitForm(formName){
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if(valid){
          signApply(JSON.stringify(_this.signInfo)).then(res => {
            // console.log(res)
            if(res.data.ReturnCode === '0000'){
              this.signInfo.subMerId = res.data.SubMerId
              this.$message({
                type:'success',
                message:'二级商户信息提交成功，请验证账户'
              });
              this.toConfirm();
            }else{
              this.$message({
                type:'error',
                message:res.data.ErrorMessage
              });
            }
          })
        }else{
          return false;
        }
      })
    },
    toConfirm(){
      this.$router.push({path: '/finance/confirm',query:{'subMerId':this.signInfo.subMerId,'account':this.signInfo.account}})
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .sp3{
    margin-left: 70px;
  }
  .note{
    margin-top: 30px;
    padding: 20px 40px;
    background: #f5f7fa;
    color: #ff5000;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
  }
</style>
